export const backgroundTexture = 'assets/textures/lined-paper.png';
export const backgroundTextureMarket = 'assets/textures/brushed-alum-dark.png';
export const backgroundTextureAlt = 'assets/textures/connected.png';
export const backgroundTextureAlt2 = 'assets/textures/brushed-alum-dark.png';